module.exports = __webpack_public_path__ + "static/03-818a72469f288896b41ee62453b53d60.jpg";